import { createSelector } from '@reduxjs/toolkit';
import { createEmbeddedConektaUrl } from 'features/payments/utils/create-embedded-conekta-url.util';

export const conektaPaymentActionSelector = state =>
  state.wnPayments.conektaPaymentAction;

export const conektaPaymentOrderIdSelector = createSelector(
  [conektaPaymentActionSelector],
  paymentAction => paymentAction?.orderId ?? null,
);

export const conektaPaymentURLSelector = createSelector(
  [conektaPaymentActionSelector],
  paymentAction =>
    paymentAction ? createEmbeddedConektaUrl(paymentAction.redirectUrl) : null,
);
